export enum GeneralError {
  UNKNOWN_ERROR = -1,
  PAYMENT_NOT_ACCEPTED = 0,
  ORDER_COULDNT_BE_SENT = 1
}
